import Add from '@mui/icons-material/Add'
import { Button, type ButtonProps, Stack, type StackProps, Typography } from '@mui/material'
import { FC, PropsWithChildren } from 'react'
import { PANEL_HEIGHT } from '../../utils/constants'
import { MonitoringAlert } from './MonitoringAlert'

const Title = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography sx={{ fontWeight: 600 }} variant="h6">
      {children}
    </Typography>
  )
}

const Description = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography component="div" variant="body2">
      {children}
    </Typography>
  )
}

type CreateButtonProps = FC<
  PropsWithChildren<{ label?: string; children: React.ReactNode } & ButtonProps>
>

const CreateButton: CreateButtonProps = ({ label, children, ...props }) => {
  return (
    <Stack spacing={2}>
      {label && <Typography variant="body2">{label}</Typography>}
      <Button
        aria-label="create"
        color="primary"
        sx={{ display: 'flex', alignItems: 'stretch' }}
        variant="contained"
        {...props}
      >
        <Add sx={{ fontSize: 20 }} />
        {children}
      </Button>
    </Stack>
  )
}

const ActionsSection: FC<PropsWithChildren<StackProps>> = ({ children, ...props }) => {
  return (
    <Stack spacing={2} {...props}>
      {children}
    </Stack>
  )
}

export const MonitoringPanel: FC<PropsWithChildren<StackProps>> & {
  Title: FC<PropsWithChildren<{ children: React.ReactNode }>>
  Description: FC<PropsWithChildren<{ children: React.ReactNode }>>
  CreateButton: CreateButtonProps
  Alert: typeof MonitoringAlert
  ActionsSection: FC<PropsWithChildren<StackProps>>
} = ({ children, ...props }) => {
  return (
    <Stack
      spacing={2}
      sx={{
        padding: '20px',
        alignItems: 'flex-start',
        overflowY: 'auto',
        height: PANEL_HEIGHT,
      }}
      {...props}
    >
      {children}
    </Stack>
  )
}

MonitoringPanel.Title = Title
MonitoringPanel.Description = Description
MonitoringPanel.CreateButton = CreateButton
MonitoringPanel.Alert = MonitoringAlert
MonitoringPanel.ActionsSection = ActionsSection
